import { useState } from 'react';
import './InviteFriends.css';
import logo from '../assets/satsat-logo.svg';

const InviteFriends = () => {
  const [copied, setCopied] = useState(false);

  const shareMessage = `Ok you NEED to join SatSat with me. It matches you with locals for shared dinners — you can host or just show up and eat 😄 It's such a vibe. Check it out: getsatsat.com`;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          text: shareMessage,
        });
      } catch (err) {
        if (err.name !== 'AbortError') {
          fallbackCopy();
        }
      }
    } else {
      fallbackCopy();
    }
  };

  const fallbackCopy = () => {
    navigator.clipboard.writeText(shareMessage);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="invite-container">
      <img src={logo} alt="SatSat Logo" className="invite-logo" />
      <h1 className="invite-title">Grow The Community, Invite your friends!</h1>
      <p className="invite-text">
        Our community welcomes curious neighbors, passionate home cooks, adventurous eaters, and anyone who simply wants to belong.
        <br /><br />
        Know someone who'd fit right in? Bring them along.
      </p>
      <button className="invite-share-button" onClick={handleShare}>
        {copied ? 'Copied!' : 'Share with Friends'}
      </button>
    </div>
  );
};

export default InviteFriends;
